import { render } from "./Message.vue?vue&type=template&id=687aba4e"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=687aba4e&lang=scss&scope=true"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__